// Wallando: Sticky Add-to-Cart Mobile — mit Produkttitel + Preis
(function() {
  if (window.innerWidth > 749) return;

  var productTitle = document.querySelector('.product__title') 
    ? document.querySelector('.product__title').innerText.trim().split('\n')[0]
    : document.title.split('–')[0].trim();

  var priceEl = document.querySelector('.price--large .money, .product__price .money, .price .money');
  var productPrice = priceEl ? priceEl.innerText.trim() : '';

  var bar = document.createElement('div');
  bar.className = 'sticky-atc';
  bar.innerHTML = [
    '<div style="display:flex;justify-content:space-between;align-items:center;gap:12px;">',
      '<div style="flex:1;min-width:0;">',
        '<div style="font-size:0.75rem;color:rgba(255,255,255,0.7);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">' + productTitle + '</div>',
        '<div style="font-size:1.1rem;font-weight:800;color:#fff;">' + productPrice + '</div>',
      '</div>',
      '<button class="sticky-atc__button" id="sticky-atc-btn" style="',
        'background:#fff;color:#1a1a1a;border:none;border-radius:8px;',
        'padding:12px 20px;font-size:0.9rem;font-weight:700;cursor:pointer;white-space:nowrap;',
      '">🛒 In den Warenkorb</button>',
    '</div>'
  ].join('');

  document.body.appendChild(bar);

  var mainBtn = document.querySelector('[name="add"]');
  if (!mainBtn) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      bar.classList.toggle('is-visible', !entry.isIntersecting);
    });
  }, { threshold: 0 });
  observer.observe(mainBtn);

  document.getElementById('sticky-atc-btn').addEventListener('click', function() {
    mainBtn.click();
  });
})();
